import React, { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import Header from './Header';
import Table from './Table';
import Pagination from './Pagination';

export default inject('root')(
  observer(({ root }) => {
    const { generalLedgerCodes, loadGeneralLedgerCodes, loading, pagination } = root.generalLedgerCodes;

    useEffect(() => {
      loadGeneralLedgerCodes();
    }, []);

    return (
      <>
        <Header />
        <Table
          loading={loading}
          generalLedgerCodes={generalLedgerCodes}
        />
         <Pagination pagination={pagination} />
      </>
    );
  })
)
